export default __webpack_public_path__ + "static/media/pride_hat.1005e02d.png";